import React, { Fragment, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Button from '../../../_library/Button'
import InlineLoader from '../../../_library/InlineLoader'
import Select from '../../../_library/Select'
import Field from '../../../_library/Field'
import modalStyle from '../../../../_common/core/modalStyle'
import { SeatsioEventManager } from '@seatsio/seatsio-react'
import { SeatsIoSeasonEventPicker } from '../../form/EventForm/SeatsIo/SeatsIoSeasonEventPicker'

export const SeatsIo = ({
  errors,
  touched,
  values,
  handleChangeEmail,
  handleChangeConfirmEmail,
  setFieldValue,
  tickets,
  handleChangeQuantity,
  addons,
  optionsAddons,
  options_quantity,
  fetchSeatsIoDataResponse,
  fetchSeatsIoDataResponseLoading,
  tables,
  setFieldTouched,
  activeSeatsIoData,
  fetchSeatsIoSelectedData,
}) => {
  useEffect(() => {
    handleChangeQuantity(0)
    setFieldValue('isSeatsIo', true)
    return () => {
      setFieldValue('isSeatsIo', false)
    }
  }, [])
  const error = errors.tickets
  const [showModal, setShowModal] = useState(false)
  const [activeSeatsIoEventId, setActiveSeatsIoEventId] = useState(values.seatsIoActiveId ?? 'main')
  const { seat_io_tickets } = values
  const updateTicketHolder = (e, ticketIndex, field) => {
    const { seat_io_tickets } = values
    seat_io_tickets[ticketIndex][field] = e.target.value
    setFieldValue('seat_io_tickets', seat_io_tickets)
  }
  const copyFirstTicketHolder = () => {
    const [firstSeat] = values.seat_io_tickets
    const seat_io_tickets = values.seat_io_tickets.map(ticket => ({
      ...ticket,
      first_name: firstSeat.first_name,
      last_name: firstSeat.last_name,
      ticketTypeId: firstSeat.ticketTypeId,
    }))
    setFieldValue('seat_io_tickets', seat_io_tickets)
  }
  const handleAddOn = ticketIndex => {
    const { seat_io_tickets } = values
    seat_io_tickets[ticketIndex].add_ons.push({
      quantity: '1',
      id: '',
    })
    setFieldValue('seat_io_tickets', seat_io_tickets)
  }
  const handleAddonChange = (e, ticketIndex, addOnIndex, field) => {
    const { seat_io_tickets } = values
    const { value } = e.target
    seat_io_tickets[ticketIndex].add_ons[addOnIndex][field] = value
    setFieldValue('seat_io_tickets', seat_io_tickets)
  }
  const handleAddonRemove = (ticketIndex, addOnIndex) => {
    const { seat_io_tickets } = values
    seat_io_tickets[ticketIndex].add_ons.splice(addOnIndex, 1)
    setFieldValue('seat_io_tickets', seat_io_tickets)
  }
  const handleTicketTypeChange = (e, ticketIndex) => {
    const { seat_io_tickets } = values
    const { value } = e.target
    seat_io_tickets[ticketIndex].ticketTypeId = value
    setFieldValue('seat_io_tickets', seat_io_tickets)
  }
  const seatsIoRef = useRef(null)
  const ticketsRef = useRef([])
  useEffect(() => {
    ticketsRef.current = seat_io_tickets
  }, [seat_io_tickets])
  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <div style={{ width: 270 }} className={'form-group ' + (error ? 'has-error' : '')}>
          <Button
            type="button"
            className="btn btn-primary btn-shadow"
            disabled={!fetchSeatsIoDataResponse && !activeSeatsIoData}
            onClick={() => setShowModal(true)}
          >
            Select Tickets On The Map
          </Button>
          {!fetchSeatsIoDataResponseLoading && !fetchSeatsIoDataResponse && !activeSeatsIoData ? (
            <div style={{ top: 1, right: -110 }} className="help-block">
              Add a Seats.io map to this event
            </div>
          ) : null}
          {!!error && touched.ticketOnTheMap && (
            <div style={{ top: 1 }} className="help-block">
              Required
            </div>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-xs-6 col-12">
          <Field
            label="Email Address"
            type="email"
            id="email"
            value={values.email}
            error={errors.email}
            touched={touched.email}
            onChange={handleChangeEmail}
          />
        </div>
        <div className="col-xs-6 col-12">
          <Field
            label="Confirm Email Address"
            type="email"
            id="confirmEmail"
            value={values.confirmEmail}
            error={errors.confirmEmail}
            touched={touched.confirmEmail}
            onChange={handleChangeConfirmEmail}
          />
        </div>
      </div>
      {values.seat_io_tickets.map((ticket, ticketIndex) => (
        <Fragment key={ticketIndex}>
          <div className="row">
            <div className="col-xs-12">
              <div className="section-title-sytle">
                <label>Ticket #{ticketIndex + 1}</label>
              </div>
            </div>
            <div className="section-title-sytle" />
            <div className="col-xs-6 col-12">
              <Select
                label="Ticket Type"
                id="ticketTypeID"
                options={[
                  ...(tickets
                    ?.filter?.(systemTicket => ticket.ticketTypeOptions.includes(systemTicket.id))
                    .map(ticket => ({
                      id: ticket.id,
                      value: ticket.id,
                      label: ticket.displayName,
                    })) ?? []),
                  ...(tables
                    ?.filter?.(systemTable => ticket.ticketTypeOptions.includes(systemTable.id))
                    .map(table => ({
                      id: table.id,
                      value: table.id,
                      label: table.displayName,
                    })) ?? []),
                ]}
                value={ticket.ticketTypeId}
                onChange={e => handleTicketTypeChange(e, ticketIndex)}
              />
            </div>
            <div className="col-xs-12">
              <label>Ticket Holder</label>
            </div>
            <div className="col-xs-4 col-lg-5 col-12">
              <Field
                id={'firstName'}
                label="First Name"
                value={values?.seat_io_tickets?.[ticketIndex]?.first_name}
                error={errors?.seat_io_tickets?.[ticketIndex]?.first_name}
                touched={touched?.seat_io_tickets?.[ticketIndex]?.first_name}
                onChange={e => updateTicketHolder(e, ticketIndex, 'first_name')}
              />
            </div>
            <div className="col-xs-4 col-lg-5 col-12">
              <Field
                id={'lastName'}
                label="Last Name"
                value={values?.seat_io_tickets?.[ticketIndex]?.last_name}
                error={errors?.seat_io_tickets?.[ticketIndex]?.last_name}
                touched={touched?.seat_io_tickets?.[ticketIndex]?.last_name}
                onChange={e => updateTicketHolder(e, ticketIndex, 'last_name')}
                onBlur={e => updateTicketHolder(e, ticketIndex, 'last_name')}
              />
            </div>
            {addons.length > 0 && (
              <div className="col-xs-2 col-12">
                <Button
                  className="btn btn-primary btn-shadow guest-ticket-form-ticketholder-add-addon-btn"
                  type="button"
                  onClick={() => handleAddOn(ticketIndex)}
                >
                  Attach Add-on
                </Button>
              </div>
            )}
            {values.seat_io_tickets.length > 1 && ticketIndex === 0 && (
              <div className="col-xs-12 col-12">
                <Button
                  className="btn btn-primary btn-shadow guest-ticket-form-ticketholder-copy"
                  type="button"
                  onClick={copyFirstTicketHolder}
                >
                  Copy details to all other tickets
                </Button>
              </div>
            )}
            {ticket.add_ons.map((addon, addOnIndex) => (
              <div key={addOnIndex} className="col-xs-12 guest-ticket-form-ticketholder-addon">
                <div className="row">
                  <div className="col-xs-4 col-lg-5 col-12">
                    <Select
                      id="addonId"
                      label={'Add On #' + (addOnIndex + 1)}
                      options={optionsAddons}
                      value={values.seat_io_tickets?.[ticketIndex]?.add_ons?.[addOnIndex]?.id}
                      error={errors.seat_io_tickets?.[ticketIndex]?.add_ons?.[addOnIndex]?.id}
                      touched={true}
                      onChange={e => handleAddonChange(e, ticketIndex, addOnIndex, 'id')}
                      onBlur={e => handleAddonChange(e, ticketIndex, addOnIndex, 'id')}
                    />
                  </div>
                  <div className="col-xs-4  col-lg-5 col-12">
                    <Select
                      id={'addon_quantity_' + ticketIndex + '_' + addOnIndex}
                      label="Quantity"
                      options={options_quantity}
                      value={values.seat_io_tickets?.[ticketIndex]?.add_ons?.[addOnIndex]?.quantity}
                      error={errors.seat_io_tickets?.[ticketIndex]?.add_ons?.[addOnIndex]?.quantity}
                      touched={true}
                      onChange={e => handleAddonChange(e, ticketIndex, addOnIndex, 'quantity')}
                      onBlur={e => handleAddonChange(e, ticketIndex, addOnIndex, 'quantity')}
                    />
                  </div>
                  <div className="col-xs-3 col-lg-2 col-12">
                    <Button
                      className="btn btn-danger btn-shadow guest-ticket-form-ticketholder-remove-addon-btn"
                      type="button"
                      onClick={() => handleAddonRemove(ticketIndex, addOnIndex)}
                    >
                      <i className="fa fa-trash" />
                      <span>Delete</span>
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Fragment>
      ))}
      {showModal && (
        <Modal
          className="modal-dialog modal-trans seatsio-modal"
          style={modalStyle}
          isOpen={true}
          contentLabel="Modal"
          onRequestClose={() => {
            setShowModal(false)
            setFieldTouched('ticketOnTheMap', true)
          }}
          closeTimeoutMS={10}
          ariaHideApp={false}
        >
          <div
            className="seatsio-modal-container"
            style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}
          >
            <div className="modal-header" style={{ marginBottom: 7 }}>
              <p className="h4 text-compact">Select Seats</p>
            </div>
            {!fetchSeatsIoDataResponse && !activeSeatsIoData && <InlineLoader />}
            <SeatsioEventManager
              ref={seatsIoRef}
              secretKey={activeSeatsIoData.workplace_secret_key}
              event={activeSeatsIoData.event_id}
              onChartRendered={chart => {
                const values = ticketsRef.current
                const selected = values.map(ticket => ({ label: ticket.seatsIoLabel }))
                chart.selectObjects(selected)
              }}
              mode="select"
              region={activeSeatsIoData.region}
              unavailableObjectsSelectable={false}
              onObjectSelected={async () => {
                const selectedObjects = await seatsIoRef.current.chart.listSelectedObjects()
                const seat_io_tickets = selectedObjects.map(seat => {
                  //We need double equals
                  //eslint-disable-next-line eqeqeq
                  const eventGroups = activeSeatsIoData.ticketTypes.find(
                    ticket => ticket.category == seat.category.key,
                  )
                  return {
                    group: seat.category.key,
                    ticketTypeId: eventGroups.ticketTypes[0].ticketType,
                    ticketTypeOptions: eventGroups.ticketTypes.map(ticket => ticket.ticketType),
                    label: eventGroups.ticketTypes[0].label,
                    seatsIoLabel: seat.label,
                    first_name: '',
                    last_name: '',
                    quantity: 1,
                    add_ons: [],
                    seats_io_event_id: activeSeatsIoEventId,
                    seats_io_seats: seat.id,
                  }
                })
                setFieldValue('seat_io_tickets', seat_io_tickets)
              }}
              onObjectDeselected={async () => {
                const selectedObjects = await seatsIoRef.current.chart.listSelectedObjects()
                const seat_io_tickets = selectedObjects.map(seat => {
                  //We need double equals
                  //eslint-disable-next-line eqeqeq
                  const eventGroups = activeSeatsIoData.ticketTypes.find(
                    ticket => ticket.category == seat.category.key,
                  )
                  return {
                    group: seat.category.key,
                    ticketTypeId: eventGroups.ticketTypes[0].ticketType,
                    ticketTypeOptions: eventGroups.ticketTypes.map(ticket => ticket.ticketType),
                    label: eventGroups.ticketTypes[0].label,
                    seatsIoLabel: seat.label,
                    first_name: '',
                    last_name: '',
                    quantity: 1,
                    add_ons: [],
                    seats_io_event_id: activeSeatsIoEventId,
                    seats_io_seats: seat.id,
                  }
                })
                setFieldValue('seat_io_tickets', seat_io_tickets)
              }}
            />
            <div className="modal-footer">
              <div className="btn-toolbar">
                {fetchSeatsIoDataResponse?.type === 'season' && (
                  <>
                 <label>You&apos;re currently seeing seat availability for seat map: </label>
                  <SeatsIoSeasonEventPicker
                    seasonData={fetchSeatsIoDataResponse}
                    preselectedSeatsIoId={activeSeatsIoEventId}
                    onEventChange={selectedEventId => {
                      fetchSeatsIoSelectedData(selectedEventId)
                      setActiveSeatsIoEventId(selectedEventId)
                      setFieldValue('seatsIoActiveId', selectedEventId)
                      setFieldValue('seat_io_tickets', [])
                    }}
                  />
                  </>
                )}
                {seat_io_tickets.length > 0 && (
                  <div
                    style={{
                      color: '#fff',
                      padding: '0 10px',
                      borderRadius: 4,
                      fontSize: 14,
                      marginRight: 10,
                      display: 'inline-block',
                    }}
                  >
                    <strong>{seat_io_tickets.length}</strong> seat{seat_io_tickets.length !== 1 ? 's' : ''} selected
                  </div>
                )}
                <Button
                  type="button"
                  className="btn btn-primary btn-shadow"
                  onClick={() => {
                    setShowModal(false)
                    setFieldTouched('ticketOnTheMap', true)
                  }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}
